class ProductTabs extends HTMLElement {
	constructor() {
	  super();
  
	  // Attach template to light DOM
	  const template = document.getElementById('product-tabs-template');
	  if (template) {
		const content = template.content.cloneNode(true);
		this.appendChild(content);
	  } else {
		console.error('Template not found');
	  }
	}
  
	connectedCallback() {
	  // Ensure DOM is ready before initializing tabs
	  requestAnimationFrame(() => {
		this.initTabs();
		this.scrollProductTabsOnClick();
	  });
	}
  
	initTabs() {
	  const tabsContainer = this.querySelector('#product-tabs'); // The container for the nav items
	  const tabs = this.querySelectorAll('.nav-link'); // All nav-link elements
	  const panes = this.querySelectorAll('.tab-pane'); // All tab-pane elements
  
	  if (!tabsContainer) {
		console.error('#product-tabs element not found');
		return;
	  }
  
	  // Clear any existing nav items (in case of re-rendering)
	  tabsContainer.innerHTML = '';
  
	  tabs.forEach((tab, index) => {
		const pane = panes[index]; // Match nav-item with the corresponding pane
		const content = pane ? pane.innerHTML.trim() : ''; // Get the content of the pane
  
		// Only add the nav-item if the pane has content
		if (content !== '') {
		  const navItem = tab.parentElement.cloneNode(true); // Clone the nav-item element
		  tabsContainer.appendChild(navItem); // Append the cloned nav-item to the tabs container
  
		  const newTab = navItem.querySelector('.nav-link'); // Get the newly appended nav-link
		  newTab.addEventListener('click', (event) => {
			event.preventDefault();
  
			// Remove active classes from all tabs and panes
			this.querySelectorAll('.nav-link').forEach((t) => t.classList.remove('active'));
			this.querySelectorAll('.tab-pane').forEach((pane) => pane.classList.remove('active'));
  
			// Add active class to the clicked tab and corresponding pane
			newTab.classList.add('active');
			pane.classList.add('active');
		  });
  
		  // Set the first available tab as active by default
		  if (index === 0) {
			newTab.classList.add('active');
			pane.classList.add('active');
		  }
		}
	  });
	}
  
	scrollProductTabsOnClick() {
	  const productTabs = this.querySelector('#product-tabs');
	  const productTabsItems = productTabs.querySelectorAll('.nav-item .nav-link');
  
	  productTabsItems.forEach((tab) => {
		tab.addEventListener('click', () => {
		  const navWidth = productTabs.offsetWidth;
		  const tabWidth = tab.offsetWidth;
		  const tabLeftOffset = tab.offsetLeft;
		  const tabRightOffset = tabLeftOffset + tabWidth;
		  let scrollTo = tabLeftOffset;
  
		  if (tabLeftOffset < productTabs.scrollLeft) {
			scrollTo = tabLeftOffset;
		  } else if (tabRightOffset > productTabs.scrollLeft + navWidth) {
			scrollTo = tabLeftOffset - navWidth + tabWidth;
		  } else {
			scrollTo = tabLeftOffset;
		  }
  
		  productTabs.scrollTo({
			left: scrollTo,
			behavior: 'smooth',
		  });
		});
	  });
	}
  }
  
  customElements.define('product-tabs', ProductTabs);  